// posteleAddClassBody
$(document).ready(function() {
  if (
    $('.breadcrumbs span').filter(function() {
      return $(this).text().trim() === 'Postele'
    }).length > 0
  ) {
    $('body').addClass('postele')
  }
})

// rostyAddClassBody
$(document).ready(function() {
  if (
    $('.breadcrumbs span').filter(function() {
      return $(this).text().trim() === 'Rošty do postele'
    }).length > 0
  ) {
    $('body').addClass('rosty')
  }
})

// posteleNaMiru
$(function() {
  $(`<li class="col-xs-6 col-sm-6 col-lg-3 col-xl-3 specialOffer">
        <a href="https://www.vyspimese.cz/form-postele-na-miru/">
            <img src="https://cdn.myshoptet.com/usr/www.vyspimese.cz/user/categories/thumb/matrace_na_m__ru.jpg" alt="Postele na míru">
            <span class="text">Postele na míru</span>
        </a>
     </li>
     <li class="item--box col-xs-6 col-sm-4 col-lg-3 col-xl-3">
        <a href="https://www.vyspimese.cz/blog/jak-vybrat-postel/" target="_blank">
            <span class="text">Jak vybrat postel | Blog</span>
        </a>
     </li>`).insertAfter('.postele .subcategories li:last-of-type')

  // Spuštění eventů
  $(document).trigger('ShoptetDOMPageContentLoaded')
  $(document).trigger('ShoptetDOMPageMoreProductsLede')
})
